import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonLabel, IonLoading, IonModal, IonPage, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, cardOutline, cashOutline, createOutline, pricetagOutline, printOutline, qrCodeOutline, walletOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { imprimirCupomComFallbackData } from '../../../../../Utils/EscPosGenerator';
import { alterarStatusProjeto, mesaGerarCupom, requestService, urlBaseCore } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import type { DescontoPayload } from '../Desconto/Desconto';
import Desconto, { converterDescontoParaValorMonetario, resolverDescontoInicial } from '../Desconto/Desconto';
import TaxaServico from '../TaxaServico/TaxaServico';
import AlterarPagamentoModal from './AlterarPagamentoModal';
import AlterarProdutosModal from './AlterarProdutosModal';
import '../../../../../components/DetalhesAtendimento/DetalhesAtendimento.css';

function iconePagamento(tipo: string) {
    const t = (tipo || '').toLowerCase();
    if (t.includes('credito') || t.includes('crédito') || t.includes('debito') || t.includes('débito') || t.includes('cartao') || t.includes('cartão')) return cardOutline;
    if (t.includes('pix')) return qrCodeOutline;
    if (t.includes('dinheiro')) return cashOutline;
    return walletOutline;
}

const CaixaDetalhes: React.FC = () => {
    const location = useLocation<any>();
    const history = useHistory<any>();
    const [mostrarAlerta] = useIonAlert();
    const [showLoading, setShowLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState('');

    const { setEsconderMenu, setNomeMenu, dadosEmpresa } = useContext(MessageContext);

    const projetoid: string = (location.state?.comanda?.pk || '').replaceAll('%23', '#');

    const [dadosComanda, setDadosComanda] = useState<any>(location.state?.comanda || {});
    const [listaItemProdutos, setListaItemProdutos] = useState<any[]>(location.state?.comanda?.produtos || []);
    const [valorTotalProdutos, setValorTotalProdutos] = useState<string>(location.state?.comanda?.valorTotalProdutos || '0,00');
    const [valorTotal, setValorTotal] = useState<string>(location.state?.comanda?.valorTotal || '0,00');
    const [descontoSelecionado, setDescontoSelecionado] = useState<DescontoPayload | undefined>(undefined);

    const [showModalTaxaServico, setShowModalTaxaServico] = useState(false);
    const [showModalDesconto, setShowModalDesconto] = useState(false);
    const [showAlterarProdutos, setShowAlterarProdutos] = useState(false);
    const [showAlterarPagamento, setShowAlterarPagamento] = useState(false);

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
        setNomeMenu('');
    });

    useEffect(() => {
        if (projetoid) carregarComanda();
    }, [projetoid]);

    useEffect(() => {
        try {
            const taxa = parseFloat((dadosComanda.taxaServico || '0').replace(/\./g, '').replace(',', '.')) || 0;
            const desconto = parseFloat((dadosComanda.desconto || '0').replace(/\./g, '').replace(',', '.')) || 0;
            const entrega = parseFloat((dadosComanda.taxaEntrega || '0').replace(/\./g, '').replace(',', '.')) || 0;
            let total = parseFloat((valorTotalProdutos || '0').replace(/\./g, '').replace(',', '.')) || 0;
            total += entrega;
            total -= desconto;
            total += total * (taxa / 100);
            setValorTotal(total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        } catch { }
    }, [valorTotalProdutos, dadosComanda.taxaServico, dadosComanda.desconto, dadosComanda.taxaEntrega]);

    useEffect(() => {
        setDescontoSelecionado((atual) => resolverDescontoInicial(dadosComanda.desconto, valorTotalProdutos, atual));
    }, [dadosComanda.desconto, valorTotalProdutos]);

    function carregarComanda() {
        const load = async () => {
            setShowLoading(true);
            try {
                const token = localStorage.getItem('token') || '';
                const resp = await fetch(
                    urlBaseCore.url + '/ordens/' + projetoid.replaceAll(/#/g, '%23') + '/semassinar',
                    { method: 'GET', headers: [['token', token]] as any, credentials: 'include' }
                );
                const response = await resp.json();
                if (response.Item) {
                    setDadosComanda(response.Item);
                    const prods = response.Item.produtos || [];
                    setListaItemProdutos(prods);
                    const total = prods.reduce((acc: number, item: any) =>
                        acc + (parseFloat(String(item.subtotal).replace(/\./g, '').replace(',', '.')) || 0), 0);
                    setValorTotalProdutos(total.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                }
            } catch (e) {
                console.error(e);
            } finally {
                setShowLoading(false);
            }
        };
        load();
    }

    async function alterar(formaPagamento: any, taxaServico: any, taxaEntrega: any, desconto: any) {
        return new Promise((resolve, reject) => {
            requestService(
                alterarStatusProjeto.url.replaceAll('{id}', projetoid.replaceAll(/#/g, '%23')) + '?alteracao=true',
                {
                    method: alterarStatusProjeto.method,
                    headers: [['token', localStorage.getItem('token') || '']] as any,
                    credentials: 'include',
                    body: JSON.stringify({ formaPagamento, taxaEntrega, taxaServico, desconto }),
                },
                history,
                (response: any) => { setDadosComanda(response); resolve(response); },
                (error: any) => { setTextToast(error.message); setShowToast(true); reject(error); }
            );
        });
    }

    async function imprimir() {
        try {
            const impresso = await imprimirCupomComFallbackData({
                projeto: dadosComanda,
                projetoid,
                dadosEmpresa,
                origem: 'CaixaDetalhes:imprimir'
            });
            if (impresso) return;
        } catch (error) {
            console.error("Erro ao imprimir cupom pela fila:", error);
        }

        return new Promise<void>((resolve, reject) => {
            const url = mesaGerarCupom.url.replace('{id}', projetoid.replaceAll(/#/g, '%23'));
            requestService(url, { method: mesaGerarCupom.method }, history,
                (data: any) => {
                    mostrarAlerta({
                        backdropDismiss: false, header: 'Cupom',
                        message: '<strong>Cupom</strong> gerado com sucesso.',
                        buttons: [
                            { text: 'Cancelar', role: 'cancel' },
                            { text: 'Visualizar', handler: () => { window.open(data, '_blank'); } }
                        ],
                    });
                    resolve();
                },
                (err: any) => { setTextToast(err?.message || 'Erro ao gerar cupom.'); setShowToast(true); reject(err); }
            );
        });
    }

    function dataFormatada(dateStr: string | undefined) {
        if (!dateStr) return '-';
        return new Date(dateStr).toLocaleString('pt-BR');
    }

    const nomeProdutoLabel = (prod: any): string => {
        if (Array.isArray(prod.descricao)) {
            if (prod.tipo === 'pizzas') return `${prod.tamanho} ${prod.quantidadeSabores} SABORES`;
            return prod.categoria || prod.descricao?.[0]?.descricao || '-';
        }
        return prod.descricao || '-';
    };

    const complementosProd = (prod: any) => {
        if (!Array.isArray(prod.descricao)) return [];
        return prod.descricao.slice(1).filter((c: any) => c.descricao);
    };

    const anotacoesFiltradas = (dadosComanda.anotacoes || [])
        .filter((a: any) => !Array.isArray(a))
        .sort((a: any, b: any) => (a.data < b.data ? 1 : -1));

    if (!projetoid) {
        return (
            <IonPage className="atendimento-detalhes-page">
                <IonHeader className="ion-no-border">
                    <IonToolbar className="atendimento-detalhes-toolbar">
                        <IonButtons slot="start"><IonButton onClick={() => history.goBack()}><IonIcon icon={arrowBack} /></IonButton></IonButtons>
                        <IonTitle>Detalhes</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="atendimento-detalhes-content"><main className="atendimento-detalhes-container"><div className="detEmpty"><h2>Nenhuma informação disponível</h2><p>Volte ao histórico e selecione um atendimento para ver os detalhes.</p></div></main></IonContent>
            </IonPage>
        );
    }

    return (
        <IonPage className="atendimento-detalhes-page">
            <IonHeader className="ion-no-border">
                <IonToolbar className="atendimento-detalhes-toolbar">
                    <IonButtons slot="start">
                        <IonButton onClick={() => history.goBack()}><IonIcon icon={arrowBack} /></IonButton>
                    </IonButtons>
                    <IonTitle>Detalhes {dadosComanda.clienteNome || 'Balcão'}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton aria-label="Imprimir cupom" onClick={async () => { setShowLoading(true); imprimir().finally(() => setShowLoading(false)); }}>
                            <IonIcon slot="icon-only" icon={printOutline} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent className="atendimento-detalhes-content">
                <IonLoading isOpen={showLoading} message="Aguarde..." />

                <main className="atendimento-detalhes-container">
                    {/* Info abertura/encerramento */}
                    <div className="detDates">
                        <div className="detDateItem">
                            <span className="detDateLabel">Abertura</span>
                            <span className="detDateValue">{dataFormatada(dadosComanda.dataCadastro)}</span>
                        </div>
                        {dadosComanda.dataAlteracao && (
                            <div className="detDateItem">
                                <span className="detDateLabel">Encerramento</span>
                                <span className="detDateValue">{dataFormatada(dadosComanda.dataAlteracao)}</span>
                            </div>
                        )}
                    </div>

                    <div className="atendimento-detalhes-grid">
                        {/* Produtos */}
                        <div className="detSection detProducts">
                            <div className="detSectionHeader">
                                <p className="detSectionTitle">Produtos</p>
                                <IonButton fill="clear" size="small" color="primary" className="detSectionEditBtn" aria-label="Alterar produtos" onClick={() => setShowAlterarProdutos(true)}>
                                    <IonIcon slot="start" icon={createOutline} />Alterar
                                </IonButton>
                            </div>
                            {listaItemProdutos.length === 0 && (
                                <span className="detMuted">Nenhum produto.</span>
                            )}
                            {listaItemProdutos.map((prod: any, pi: number) => {
                                const complementos = complementosProd(prod);
                                return (
                                    <div key={'caixaprod' + pi} className="detProdRow">
                                        <div className="detProdInfo">
                                            <span className="detProdNome">
                                                <b>{Number(prod.quantidade).toLocaleString('pt-br', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}x</b> {nomeProdutoLabel(prod)}
                                            </span>
                                            {complementos.map((c: any, ci: number) => (
                                                <span key={'comp' + pi + ci} className="detCompItem">
                                                    {c.categoria === 'Observação' ? `Obs: ${c.descricao}` : `+ ${c.descricao}${c.valor && c.valor !== '0,00' ? ` (R$ ${c.valor})` : ''}`}
                                                </span>
                                            ))}
                                            {prod.anotacao && <span className="detProdObs">{prod.anotacao}</span>}
                                        </div>
                                        <div className="detProdPreco">
                                            <span className="detProdUnit">unt. R$ {prod.valor}</span>
                                            <span className="detProdSubtotal">R$ {prod.subtotal}</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Resumo Financeiro */}
                        <div className="detSection">
                            <div className="detSectionHeader">
                                <p className="detSectionTitle">Resumo</p>
                                <div style={{ display: 'flex', gap: '2px' }}>
                                    <IonButton fill="clear" size="small" color="primary" className="detSectionEditBtn" title="Desconto" aria-label="Alterar desconto" onClick={() => setShowModalDesconto(true)}>
                                        <IonIcon slot="icon-only" icon={pricetagOutline} />
                                    </IonButton>
                                    <IonButton fill="clear" size="small" color="primary" className="detSectionEditBtn" title="Taxa de serviço" aria-label="Alterar taxa de serviço" onClick={() => setShowModalTaxaServico(true)}>
                                        <IonLabel style={{ fontSize: '22px', fontWeight: 'bold' }}>%</IonLabel>
                                    </IonButton>
                                </div>
                            </div>
                            <div className="detResumoRow">
                                <span>Subtotal produtos</span>
                                <span>R$ {valorTotalProdutos}</span>
                            </div>
                            {dadosComanda.taxaServico && (
                                <div className="detResumoRow">
                                    <span>Taxa de serviço ({dadosComanda.taxaServico}%)</span>
                                    <span>R$ {(
                                        (parseFloat((valorTotalProdutos || '0').replace(/\./g, '').replace(',', '.')) || 0)
                                        * (parseFloat((dadosComanda.taxaServico || '0').replace(/\./g, '').replace(',', '.')) || 0)
                                        / 100
                                    ).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </div>
                            )}
                            {dadosComanda.taxaEntrega && (
                                <div className="detResumoRow">
                                    <span>Taxa de entrega</span>
                                    <span>R$ {dadosComanda.taxaEntrega}</span>
                                </div>
                            )}
                            {dadosComanda.desconto && (
                                <div className="detResumoRow detDesconto">
                                    <span>Desconto</span>
                                    <span>- R$ {dadosComanda.desconto}</span>
                                </div>
                            )}
                            <div className="detTotalRow">
                                <span>Total</span>
                                <span>R$ {valorTotal}</span>
                            </div>
                            {/* {(() => {
                        const prods = listaItemProdutos || [];
                        const temSnapshot = prods.some((p: any) => p.snapshot);
                        if (!temSnapshot) return null;
                        const custoTotal = prods.reduce((acc: number, p: any) => acc + (p.snapshot?.custoTotal || 0), 0);
                        const lucroBruto = prods.reduce((acc: number, p: any) => acc + (p.snapshot?.lucroBruto || 0), 0);
                        const lucroLiquido = prods.reduce((acc: number, p: any) => acc + (p.snapshot?.lucroLiquido ?? p.snapshot?.lucroBruto ?? 0), 0);
                        const totalValor = parseFloat((valorTotal || '0').replace(/\./g, '').replace(',', '.')) || 0;
                        const margem = totalValor > 0 ? (lucroBruto / totalValor) * 100 : 0;
                        return (
                            <>
                                <div className="detResumoRow" style={{ marginTop: '8px', borderTop: '1px dashed #ccc', paddingTop: '8px' }}>
                                    <span>Custo total</span>
                                    <span>R$ {custoTotal.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </div>
                                <div className="detResumoRow">
                                    <span>Lucro bruto</span>
                                    <span style={{ color: lucroBruto >= 0 ? '#2dd36f' : '#eb445a' }}>R$ {lucroBruto.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </div>
                                <div className="detResumoRow">
                                    <span>Lucro líquido</span>
                                    <span style={{ color: lucroLiquido >= 0 ? '#2dd36f' : '#eb445a' }}>R$ {lucroLiquido.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </div>
                                <div className="detResumoRow">
                                    <span>Margem</span>
                                    <span style={{ color: margem >= 0 ? '#2dd36f' : '#eb445a' }}>{margem.toFixed(1)}%</span>
                                </div>
                            </>
                        );
                    })()} */}
                        </div>

                        {/* Formas de Pagamento */}
                        <div className="detSection">
                            <div className="detSectionHeader">
                                <p className="detSectionTitle">Pagamento</p>
                                <IonButton fill="clear" size="small" color="primary" className="detSectionEditBtn" aria-label="Alterar pagamento" onClick={() => setShowAlterarPagamento(true)}>
                                    <IonIcon slot="start" icon={createOutline} />Alterar
                                </IonButton>
                            </div>
                            {(dadosComanda.formaPagamento?.length > 0) ? (
                                <>
                                    {dadosComanda.formaPagamento.map((pag: any, fi: number) => (
                                        <div key={'caixapag' + fi} className="detPagRow">
                                            <IonIcon icon={iconePagamento(pag.tipo || pag.pagamento)} className="detPagIcon" />
                                            <span className="detPagTipo">{pag.tipo || pag.pagamento}</span>
                                            <span className="detPagValor">R$ {pag.valor}</span>
                                        </div>
                                    ))}
                                    {dadosComanda.troco && dadosComanda.troco !== '0,00' && (
                                        <div className="detResumoRow detTroco">
                                            <span>Troco</span>
                                            <span>R$ {dadosComanda.troco}</span>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <span className="detMuted">Nenhum pagamento registrado.</span>
                            )}
                        </div>

                        {/* Anotações */}
                        {anotacoesFiltradas.length > 0 && (
                            <div className="detSection detNotes">
                                <p className="detSectionTitle">Anotações</p>
                                {anotacoesFiltradas.map((anotacao: any) => (
                                    <div key={'caixaanot' + anotacao.id} className="detAnotRow">
                                        <span className="detAnotMeta">
                                            {new Date(anotacao.data).toLocaleDateString('pt-BR')} {new Date(anotacao.data).toLocaleTimeString('pt-BR')}
                                            {anotacao.pessoa && <b> · {anotacao.pessoa}</b>}
                                        </span>
                                        <span className="detAnotTexto">{anotacao.anotacao}</span>
                                    </div>
                                ))}
                            </div>
                        )}

                    </div>
                </main>

                {/* Modal: Taxa de serviço */}
                <IonModal isOpen={showModalTaxaServico} onDidDismiss={() => setShowModalTaxaServico(false)}>
                    <TaxaServico
                        projetoid={projetoid.replaceAll(/#/g, '%23')}
                        valorInicial={dadosComanda.taxaServico}
                        modalAberto={showModalTaxaServico}
                        closeAction={async (taxa: any) => {
                            setShowModalTaxaServico(false);
                            await alterar(dadosComanda.formaPagamento, taxa, dadosComanda.taxaEntrega, dadosComanda.desconto);
                            carregarComanda();
                        }}
                        closeActionSimple={() => setShowModalTaxaServico(false)}
                    />
                </IonModal>

                {/* Modal: Desconto */}
                <IonModal isOpen={showModalDesconto} onDidDismiss={() => setShowModalDesconto(false)}>
                    <Desconto
                        projetoid={projetoid.replaceAll(/#/g, '%23')}
                        totalBase={valorTotalProdutos}
                        valorInicial={descontoSelecionado}
                        modalAberto={showModalDesconto}
                        closeAction={async (desc: DescontoPayload) => {
                            setShowModalDesconto(false);
                            setDescontoSelecionado(desc);
                            const descontoMonetario = converterDescontoParaValorMonetario(desc, valorTotalProdutos);
                            await alterar(dadosComanda.formaPagamento, dadosComanda.taxaServico, dadosComanda.taxaEntrega, descontoMonetario);
                            carregarComanda();
                        }}
                        closeActionSimple={() => setShowModalDesconto(false)}
                    />
                </IonModal>

                {/* Modal: Alterar Produtos */}
                <IonModal className="fullscreen-modal" isOpen={showAlterarProdutos} onDidDismiss={() => setShowAlterarProdutos(false)}>
                    <AlterarProdutosModal
                        projetoid={projetoid.replaceAll(/#/g, '%23')}
                        listaInicial={listaItemProdutos}
                        dadosComandas={dadosComanda}
                        dadosEmpresa={dadosEmpresa}
                        onClose={() => setShowAlterarProdutos(false)}
                        onConfirm={(attrs: any) => {
                            setDadosComanda(attrs);
                            const prods = attrs.produtos || [];
                            setListaItemProdutos(prods);
                            const total = prods.reduce((acc: number, item: any) =>
                                acc + (parseFloat(String(item.subtotal).replace(/\./g, '').replace(',', '.')) || 0), 0);
                            setValorTotalProdutos(total.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                            setShowAlterarProdutos(false);
                            setTextToast('Produtos atualizados!');
                            setShowToast(true);
                        }}
                    />
                </IonModal>

                {/* Modal: Alterar Pagamento */}
                <IonModal className="fullscreen-modal" isOpen={showAlterarPagamento} onDidDismiss={() => setShowAlterarPagamento(false)}>
                    <AlterarPagamentoModal
                        projetoid={projetoid.replaceAll(/#/g, '%23')}
                        dadosComandas={dadosComanda}
                        onClose={() => setShowAlterarPagamento(false)}
                        onConfirm={(novaComanda: any) => {
                            if (novaComanda) setDadosComanda(novaComanda);
                            setShowAlterarPagamento(false);
                            setTextToast('Pagamento atualizado!');
                            setShowToast(true);
                        }}
                    />
                </IonModal>

                <IonToast isOpen={showToast} position="middle" onDidDismiss={() => setShowToast(false)} message={textToast} duration={3000} />
            </IonContent>
        </IonPage>
    );
};

export default CaixaDetalhes;
